import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';

interface ConfirmDialogProps {
    open: boolean;
    title: string;
    message?: React.ReactNode;
    confirmLabel?: string;
    destructive?: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ open, title, message, confirmLabel = 'Confirm', destructive = false, onConfirm, onClose }) => (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>{title}</DialogTitle>
        {message && (
            <DialogContent>
                <Typography variant="body2" color="textSecondary">{message}</Typography>
            </DialogContent>
        )}
        <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <Button
                variant="contained"
                color={destructive ? 'error' : 'primary'}
                onClick={() => {
                    onConfirm();
                    onClose();
                }}
            >
                {confirmLabel}
            </Button>
        </DialogActions>
    </Dialog>
);

export default ConfirmDialog;
